/* eslint-disable */

import Vue from 'vue';
import VueRouter from 'vue-router';

import AboutUs from '@/pages/about-us/Index.vue';
import Career from '@/pages/career/Index.vue';
import Contacts from '@/pages/contacts/Index.vue';
import Main from '@/pages/main/Index.vue';
import News from '@/pages/news/Index.vue';
import NewsItem from '@/pages/news/Item.vue';
import NotFound from '@/pages/not-found/Index.vue';
import PrivacyPolicy from '@/pages/privacy-policy/Index.vue';
import Certificazioni from '@/pages/certificazioni/Index.vue';

Vue.use(VueRouter);

const routes = [
    {
      component: AboutUs,
      name: 'AboutUs',
      path: '/about',
      meta: {
        title: '4MKTG | Trade marketing projects — about us',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — about us',
          },
          {
            name: 'description',
            content: 'Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. ',
          },
          {
            property: 'og:description',
            content: 'Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. ',
          },
        ],
      },
    },
    {
      component: Career,
      name: 'Career',
      path: '/career',
      meta: {
        title: '4MKTG | Trade marketing projects — career',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — career',
          },
          {
            name: 'description',
            content: 'Siamo sempre alla ricerca di nuovi talenti per incrementare il nostro team: passione, impegno e volontà di portare buoni risultati sono requisiti indispensabili.',
          },
          {
            property: 'og:description',
            content: 'Siamo sempre alla ricerca di nuovi talenti per incrementare il nostro team: passione, impegno e volontà di portare buoni risultati sono requisiti indispensabili.',
          },
        ],
      },
    },
    {
      component: Contacts,
      name: 'Contacts',
      path: '/contacts',
      meta: {
        title: '4MKTG | Trade marketing projects — contacts',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — contacts',
          },
          {
            name: 'description',
            content: 'Headquarter: tel. +390396854596 | Email: info@4mktg.it |Ind.: Via Torri Bianche 10 edificio Betulla | CAP: 20871 Vimercate',
          },
          {
            property: 'og:description',
            content: 'Headquarter: tel. +390396854596 | Email: info@4mktg.it |Ind.: Via Torri Bianche 10 edificio Betulla | CAP: 20871 Vimercate',
          },
        ],
      },
    },
    {
      component: NewsItem,
      name: 'NewsItem',
      path: '/news/:id(\\d+)',
      props: (route) => ({id: +route.params.id}),
      meta: {
        title: '4MKTG | Trade marketing projects — news',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — news',
          },
          {
            name: 'description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
          {
            property: 'og:description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
        ],
      },
    },
    {
      component: News,
      name: 'News',
      path: '/news',
      meta: {
        title: '4MKTG | Trade marketing projects — news',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — news',
          },
          {
            name: 'description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
          {
            property: 'og:description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
        ],
      },
    },
    {
      component: PrivacyPolicy,
      name: 'PrivacyPolicy',
      path: '/privacy',
      meta: {
        title: '4MKTG | Trade marketing projects — privacy',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — privacy',
          },
          {
            name: 'description',
            content: '4MKTG | Trade marketing projects — privacy',
          },
          {
            property: 'og:description',
            content: '4MKTG | Trade marketing projects — privacy',
          },
        ],
      },
    },
    {
      component: Certificazioni,
      name: 'Certificazioni',
      path: '/certificazioni',
      meta: {
        title: '4MKTG | Trade marketing projects — certificazioni',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — certificazioni',
          },
          {
            name: 'description',
            content: '4MKTG | Trade marketing projects — certificazioni',
          },
          {
            property: 'og:description',
            content: '4MKTG | Trade marketing projects — certificazioni',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/',
      meta: {
        title: '4MKTG | Trade marketing projects',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects',
          },
          {
            name: 'description',
            content: 'Dal 1996 siamo un partner affidabile per la realizzazione di progetti che uniscono efficienza e creatività. Proveniamo da esperienze in multinazionali pertanto conosciamo bene le aspettative delle aziende e riusciamo ad essere autonomi nella gestione dei progetti.',
          },
          {
            property: 'og:description',
            content: 'Dal 1996 siamo un partner affidabile per la realizzazione di progetti che uniscono efficienza e creatività. Proveniamo da esperienze in multinazionali pertanto conosciamo bene le aspettative delle aziende e riusciamo ad essere autonomi nella gestione dei progetti.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(gdo)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — presidio GDO',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — presidio GDO',
          },
          {
            name: 'description',
            content: 'La miglior visibilità a scaffale e in extra display. Mettiamo il&nbsp;tuo prodotto nelle mani del consumatore.',
          },
          {
            property: 'og:description',
            content: 'La miglior visibilità a scaffale e in extra display. Mettiamo il&nbsp;tuo prodotto nelle mani del consumatore.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(merchandising)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — sampling & merchandising',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — sampling & merchandising',
          },
          {
            name: 'description',
            content: 'Gestiamo tutte le fasi del progetto: creatività, produzione, logistica, selezione del personale; pertanto, tutto quello che&nbsp;proponiamo è creativo, ma realizzabile senza intoppi in fase di operatività.',
          },
          {
            property: 'og:description',
            content: 'Gestiamo tutte le fasi del progetto: creatività, produzione, logistica, selezione del personale; pertanto, tutto quello che&nbsp;proponiamo è creativo, ma realizzabile senza intoppi in fase di operatività.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(horeca)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — horeca',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — horeca',
          },
          {
            name: 'description',
            content: 'Presentiamo nuovi prodotti per un corretto posizionamento, aumentiamo la distribuzione e/o le referenze trattate, rendiamo visibili i prodotti per generare richiesta spontanea.',
          },
          {
            property: 'og:description',
            content: 'Presentiamo nuovi prodotti per un corretto posizionamento, aumentiamo la distribuzione e/o le referenze trattate, rendiamo visibili i prodotti per generare richiesta spontanea.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(mystery-client)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — mystery client',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — mystery client',
          },
          {
            name: 'description',
            content: 'Verifichiamo capillarmente l’applicazione delle guide lines delle aziende nostre clienti da parte dei loro partner locali: esposizione e presentazione di prodotti o servizi, effettuazione delle promozioni, proattività del personale.',
          },
          {
            property: 'og:description',
            content: 'Verifichiamo capillarmente l’applicazione delle guide lines delle aziende nostre clienti da parte dei loro partner locali: esposizione e presentazione di prodotti o servizi, effettuazione delle promozioni, proattività del personale.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(events)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — events',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — events',
          },
          {
            name: 'description',
            content: 'Creatività, location, target: i migliori eventi per far desiderare il tuo prodotto ai consumatori.',
          },
          {
            property: 'og:description',
            content: 'Creatività, location, target: i migliori eventi per far desiderare il tuo prodotto ai consumatori.',
          },
        ],
      },
    },
    // {
    //   component: Main,
    //   name: 'Main',
    //   path: '/:slideURL(popupvillage)',
    //   props: true,
    //   meta: {
    //     title: '4MKTG | Trade marketing projects — event village experience',
    //     metaTags: [
    //       {
    //         name: 'og:title',
    //         content: '4MKTG | Trade marketing projects — event village experience',
    //       },
    //       {
    //         name: 'description',
    //         content: 'Il Pop Up Village è un vero e proprio villaggio creato da camper all’interno di grandi eventi sportivi, musicali e di intrattenimento.',
    //       },
    //       {
    //         property: 'og:description',
    //         content: 'Il Pop Up Village è un vero e proprio villaggio creato da camper all’interno di grandi eventi sportivi, musicali e di intrattenimento.',
    //       },
    //     ],
    //   },
    // },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(creative)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — creative',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — creative',
          },
          {
            name: 'description',
            content: 'Idee creative per presentare il tuo prodotto al trade e ai consumatori.',
          },
          {
            property: 'og:description',
            content: 'Idee creative per presentare il tuo prodotto al trade e ai consumatori.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(logistics)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — logistics',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — logistics',
          },
          {
            name: 'description',
            content: 'Le location adatte, il target corretto. I migliori eventi per far desiderare il tuo prodotto ai consumatori.',
          },
          {
            property: 'og:description',
            content: 'Le location adatte, il target corretto. I migliori eventi per far desiderare il tuo prodotto ai consumatori.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(mr-root)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — plant-based food solutions',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — plant-based food solutions',
          },
          {
            name: 'description',
            content: 'Mr. Root è una divisione di 4MKTG dedicata alla distribuzione di prodotti plant based premium.',
          },
          {
            property: 'og:description',
            content: 'Mr. Root è una divisione di 4MKTG dedicata alla distribuzione di prodotti plant based premium.',
          },
        ],
      },
    },
    {
      alias: '*',
      component: NotFound,
      name: 'NotFound',
      path: '/404',
      meta: {
        title: '4MKTG | Trade marketing projects — Not Found',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
          {
            name: 'description',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
          {
            property: 'og:description',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
        ],
      },
    },
  ];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  linkActiveClass: 'link_active',
  linkExactActiveClass: 'link_exact',
  routes: routes,
});
let stopScrollFlag = false;

router.beforeEach((to, from, next) => {
  if (stopScrollFlag) {
    return;
  }

  const nearestWithTitle = to.matched.slice().reverse().find((r) =>
    (r.meta && r.meta.title)
  );

  if (to.hash === '#100') {
    setTimeout(() => {
      window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: 'smooth'});
    }, 200);
  }

  const nearestWithMeta = to.matched.slice().reverse().find((r) =>
    r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  const element = document.querySelectorAll('[data-vue-router-controlled]');
  Array.from(element).map((el) =>
    el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;

/**
 * @param {Object} to
 * @param {Object} from
 * @param {Object} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
  if (to && to.hash) {
    return {
      selector: to.hash,
      behavior: 'smooth'
    };
  } else if (savedPosition) {
      return savedPosition;
  } else {
      return { x: 0, y: 0 };
  }
}

window.addEventListener('wheel', (event) => {    
  stopScrollFlag = event.target.closest('body.nav-open') ? true : false;
  setTimeout(() => stopScrollFlag = false, 200);
});
window.addEventListener('click', (event) => {
  stopScrollFlag = false
});



// WEBPACK FOOTER //
// ./src/router/index.js